var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 104"}},[_c('g',{staticClass:"cls-1"},[_c('line',{attrs:{"x1":"52","y1":"4","x2":"52","y2":"75"}}),_c('line',{attrs:{"x1":"27","y1":"4","x2":"77","y2":"4"}}),_c('path',{attrs:{"stroke-linecap":"square","d":"M 52 75 a 12.5 12.5 0 1 1 -12.5 12.5"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }